import { Badge } from '@mui/material';
import React, { ReactNode } from 'react';
import LockIcon from 'src/assets/navbar-icons/lock-icon.svg';
import LockIconActive from 'src/assets/navbar-icons/lock-icon-active.svg';

interface IProps {
  expanded: boolean;
  icon: ReactNode;
  title: string;
  permission: boolean;
  onClick: (e?: any) => void;
  isActive: boolean;
  className?: string;
  isLocked: boolean;
}

function NavbarItem({
  expanded,
  icon,
  title,
  onClick,
  permission,
  isActive,
  className,
  isLocked,
}: IProps) {
  const activeLockBadge = isActive ? (
    <img src={LockIconActive} alt="lock-icon-active" width="16" height="16" className="nav-lock-icon" />
  ) : (
    <img src={LockIcon} alt="lock-icon" width="16" height="16" className="nav-lock-icon" />
  );
  return (
    <Badge
      invisible={!isLocked || expanded}
      badgeContent={activeLockBadge}
      className="permission-badge"
    >
      <div
        className={`navbar-v2-item ${expanded ? 'navbar-v2-item-expanded' : ''} ${
          isActive ? 'navbar-v2-item-active' : ''
        } ${className}`}
        onClick={onClick}
      >
        {icon}
        {<p className={`navbar-v2-item-text ${expanded ? '-expanded' : '-collapsed'}`}>{title}</p>}
        {expanded && isLocked && activeLockBadge}
      </div>
    </Badge>
  );
}

export default NavbarItem;
